import './Card.scss'
import React from "react";
import RenderProps from '../../helpers/RenderProps';

enum Structure {
    card = 'card',
    media = 'card_media',
    title = 'card_title',
    subtitle = 'card_subtitle',
    contentBox = 'card_content_box',
    content = 'card_content',
    actions = 'card_actions',
    actionsBox = 'card_actions_box',
    infoBox = 'card_info_box'
}
export default function Card(props: Hotelstouch.WebApp.Components.Card.Import){
    return <div className={`${Structure.card} ${props.class || ''}`} style={props.style}>
        {props.media && <div className={Structure.media}>
            <img src={props.media} />
        </div>}
        {props.info && <div className={Structure.infoBox}>{RenderProps(props, 'info')}</div>}
        <div className={Structure.contentBox}>
            {props.title && <h2 className={Structure.title}>{props.title}</h2>}
            {props.subtitle && <><div className={Structure.subtitle}>{props.subtitle}</div></>}
            {(props.title || props.subtitle) && props.render && <br />}
            {props.render && <div className={Structure.content}>{RenderProps(props, 'render')}</div>}
        </div>
        {props.actions && <div className={Structure.actionsBox}>
            <br />
            <div className={Structure.actions}>{RenderProps(props, 'actions')}</div>
        </div>}
    </div>
}

export const cardStyles = {
    horizontal: 'card_horizontal'
}